import Command from '@ckeditor/ckeditor5-core/src/command';

const type = {
  REPLACE: 'replace',
  INSERT: 'insert'
};

export default class AiAssistantCommand extends Command {
  execute(option) {
    option.type === type.REPLACE && this._replaceSelection(option.content);
    option.type === type.INSERT && this._insertContent(option.content);
  }

  _replaceSelection(content) {
    const editor = this.editor;
    editor.model.change(writer => {
      const range = editor.model.document.selection.getFirstRange();
      editor.model.insertContent(writer.createText(content), range)
    });
  }

  _insertContent(content) {
    const editor = this.editor;
    editor.model.change(writer => {
      const selection = editor.model.document.selection;
      const position = selection.getLastPosition();
      editor.model.insertContent(writer.createText(` ${content}`), position);
    });
  }

}
